import {useRouter} from 'next/compat/router'
import {useMemo} from 'react'
import type {Translate} from 'src/common/i18n'
import {createTranslator} from 'src/common/i18n'
import {DEFAULT_LANGUAGE_CODE} from 'src/common/utils/locale'

export const useTranslate = (): Translate => {
  const locale = useRouter()?.locale ?? DEFAULT_LANGUAGE_CODE
  return useMemo(() => createTranslator(locale), [locale])
}
